import Tasks from 'APP/Tasks';
import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { getAvatarUrlByType } from 'APP/components/Avatar/Avatar.utils';

export default async (users) => {
  if (users.length === 0) {
    return;
  }

  const promises = users.reduce((memo, item) => {
    if (!item.avatarUrl) {
      return memo;
    }

    const url = getAvatarUrlByType(AvatarTypes.Round_0, item.avatarUrl);
    const promise = Tasks.app.preloadImage(url);
    memo.push(promise);

    return memo;
  }, []);

  await Promise.all(promises);
};
